import React, { createContext, useContext } from "react";
import { ROLES } from "../roles";

const RoleContext = createContext(ROLES.product);

export const RoleProvider = ({ role, children }) => (
  <RoleContext.Provider value={role}>{children}</RoleContext.Provider>
);

export const useRole = () => useContext(RoleContext);
